export default __webpack_public_path__ + "static/stylization_generator_bg-af5ff4255c9e4cfc5ff542f515a116e4.png";